import service from "./auth";

export function getOrderList(param) {
    return service({
        method: 'get',
        url: '/order/list',
        params: param
    })
}

export function checkinOrder(param) {
    return service({
        method: 'post',
        url: '/order/checkin',
        params: { order_id: param }
    })
}

export function checkoutOrder(data) {
    return service({
        method: 'post',
        url: '/order/checkout',
        data: data
    })
}

export function updateOrder(param, data) {
    return service({
        method: 'post',
        url: '/order/update',
        params: { order_id: param },
        data: data
    })
}

export function cancelOrder(param) {
    return service({
        method: 'post',
        url: '/order/cancel',
        params: { order_id: param },
    })
}


export function getTransRecord(param) {
    return service({
        method: 'get',
        url: '/order/transrecord',
        params: { user_id: param },
    })
}

export function applyCheckoutOrder(param) {
    return service({
        method: 'get',
        url: '/order/applycheckout',
        params: { order_id: param },
    })
}

export function createOrder(data) {
    return service({
        method: 'post',
        url: '/order/create',
        data: data
    })
}

export function undoTransaction(data) {
    return service({
        method: 'delete',
        url: '/order/undotrans',
        data: data
    })
}